import { ReactComponent as CloseBtn } from "../../../../assets/icons/x-close.svg";
import FrontSystemsScreen1 from "../../../../assets/images/fs-pos-thumb1.png";
import FrontSystemsScreen2 from "../../../../assets/images/fs-pos-thumb2.png";
import FrontSystemsScreen3 from "../../../../assets/images/fs-pos-thumb3.png";
import FrontSystemsScreen4 from "../../../../assets/images/fs-pos-thumb4.png";
import FrontSystemsScreen1Full from "../../../../assets/images/fs-pos-full1.png";
import FrontSystemsScreen2Full from "../../../../assets/images/fs-pos-full2.png";
import FrontSystemsScreen3Full from "../../../../assets/images/fs-pos-full3.png";
import FrontSystemsScreen4Full from "../../../../assets/images/fs-pos-full4.png";
import { ReactComponent as PrevBtn } from "../../../../assets/icons/chevron-left1.svg";
import styled from "styled-components";
import { useState } from "react";

// #region GLOBAL CONSTANTS
const SCREENS = [
    { nr: 1, thumb: FrontSystemsScreen1, full: FrontSystemsScreen1Full },
    { nr: 2, thumb: FrontSystemsScreen2, full: FrontSystemsScreen2Full },
    { nr: 3, thumb: FrontSystemsScreen3, full: FrontSystemsScreen3Full },
    { nr: 4, thumb: FrontSystemsScreen4, full: FrontSystemsScreen4Full }
];
// #endregion

// #region SCOPED CSS
const StyledPage = styled.div`
    & {
        display: flex;
        justify-content: center;
        align-items: center;
        height: auto;
        margin-right: -23px;
        margin-left: -24px;
        padding-left: 24px;
        padding-right: 24px;
    }

    .checklist-container {
        background: var(--backgrounds-and-lines-n-400, #1e2631);
        border-radius: 4px;
        padding: 16px 0px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: stretch;
        width: 100%;
        overflow: hidden;
    }

    /* ---- HEADER ---- */
    .checklist-header {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .checklist-title-row {
        padding: 0 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .checklist-title {
        color: #ffffff;
        font-size: 14px;
        letter-spacing: 0.015em;
        font-weight: 500;
        text-transform: uppercase;
    }

    .x-close {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        cursor: pointer;
        overflow: visible;
    }

    .checklist-divider {
        margin-top: -1px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-100, #3c485a);
        border-width: 1px 0 0 0;
        height: 0px;
    }

    /* ---- INFO CARD ---- */
    .info-card {
        background: var(--backgrounds-and-lines-n-300, #1a222d);
        border-radius: 16px;
        padding: 16px 24px;
        margin: 0 16px;
        backdrop-filter: blur(50px);
    }

    .info-card-text {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: justified;
    }

    .info-card-text-main {
        font-size: 14px;
        letter-spacing: 0.0025em;
        font-weight: 400;
        text-align: start;
        display: block;
    }

    .info-card-text-sub {
        font-size: 12px;
        letter-spacing: 0.0025em;
        font-weight: 400;
        text-align: start;
        display: block;
    }

    /* ---- MAIN CONTENT (text left, images right) ---- */
    .checklist-content {
        padding: 0 16px;
        display: flex;
        flex-direction: row;
        gap: 24px;
        align-items: stretch;
    }

    /* -- Left: Text descriptions -- */
    .checklist-texts {
        display: flex;
        flex-direction: column;
        gap: 16px;
        flex-shrink: 0;
        width: 349px;
    }

    .text-item {
        background: var(--backgrounds-and-lines-n-300, #1a222d);
        border-radius: 16px;
        padding: 16px 24px;
        backdrop-filter: blur(50px);
    }

    .text-item-content {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 14px;
        letter-spacing: 0.0025em;
        font-weight: 400;
        line-height: 16px;
    }

    /* -- Right: Images grid -- */
    .checklist-images {
        flex: 1;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
        align-content: start;
    }

    .image-card {
        background: var(--backgrounds-and-lines-n-300, #1a222d);
        border-radius: 16px;
        padding: 16px 24px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: center;
        backdrop-filter: blur(50px);
        height: 232px;
    }

    .ipad-wrapper {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        height: 160px;
    }

    .ipad-device {
        position: relative;
        width: 220px;
        height: 155px;
    }

    .ipad-device .ipad-screen {
        position: absolute;
        top: 5%;
        left: 5%;
        width: 90%;
        height: 90%;
        z-index: 1;
    }

    .image-label-pill {
        background: #232832;
        border-radius: 9999px;
        padding: 6px 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 10px 18px 200px 0px rgba(0, 0, 0, 1);
    }

    .image-label-text {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: center;
        font-size: 10px;
        font-weight: 400;
    }
`;
// #endregion

export default function POSChecklistPopup({ onClose }) {
    // #region STATES
    const [showScreenNr, setShowScreenNr] = useState(null);
    // #endregion

    return (
        <StyledPage>
            <div className="checklist-container" style={{ maxWidth: showScreenNr ? "100%" : "986px" }}>
                {/* ---- HEADER ---- */}
                <div className="checklist-header">
                    <div className="checklist-title-row">
                        <div className="checklist-title">heyBO x front systems checklist</div>

                        <div className="checklist-title-row">
                            <PrevBtn
                                className={`d-none prev-btn mr-10px cursor-pointer ${showScreenNr ? "" : "d-none"}`}
                                width="20px"
                                height="20px"
                                onClick={() => setShowScreenNr(null)}
                            />

                            <CloseBtn className="x-close" onClick={onClose} />
                        </div>
                    </div>
                    <div className="checklist-divider"></div>
                </div>

                {!showScreenNr ? (
                    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                        {/* ---- INFO CARD ---- */}
                        <div className="info-card">
                            <div className="info-card-text">
                                <span className="info-card-text-main">
                                    The following options can be configured at the Company, Region, or Store/POS level.
                                    Settings automatically inherit values from the level above unless a specific
                                    override is applied.
                                    <br />
                                    <br />
                                </span>
                                <span className="info-card-text-sub">
                                    For example: one POS within a store may inherit all settings from the Company level,
                                    while another POS in the same store may have its own customized configuration. These
                                    two scenarios represent opposite ends of the configuration spectrum, both fully
                                    supported by the inheritance model.
                                </span>
                            </div>
                        </div>

                        {/* ---- MAIN CONTENT ---- */}
                        <div className="checklist-content">
                            {/* -- Left: Text descriptions -- */}
                            <div className="checklist-texts">
                                <div className="text-item" style={{ height: "64px" }}>
                                    <div className="text-item-content">
                                        Your store is using Front Systems' POS app version (tablet). Find the Store ID
                                        (Image 01)
                                    </div>
                                </div>
                                <div className="text-item" style={{ height: "64px" }}>
                                    <div className="text-item-content">
                                        The Omnichannel feature for this store, is turned ON (image 02).
                                    </div>
                                </div>
                                <div className="text-item" style={{ height: "80px" }}>
                                    <div className="text-item-content">
                                        The printer options to print BOtag Courier and Shipping labels for this store
                                        are enabled (image 03).
                                    </div>
                                </div>
                                <div className="text-item" style={{ height: "80px" }}>
                                    <div className="text-item-content">
                                        The 'POS and Online' option, on 'Configure refund for omnichannel' is selected
                                        for this store.
                                    </div>
                                </div>
                                <div className="text-item" style={{ height: "128px" }}>
                                    <div className="text-item-content">
                                        The Store External ID is configured for this store.
                                        <br />
                                        You can do it yourself. This ID can match the Store ID or be any value you want
                                        (a name, for example), but it must be filled in and not left blank (image 04).
                                    </div>
                                </div>
                            </div>

                            {/* -- Right: Images grid (2x2) -- */}
                            <div className="checklist-images">
                                {SCREENS.map(({ nr, thumb }) => (
                                    <div className="image-card" key={nr}>
                                        <div className="ipad-wrapper">
                                            <div className="ipad-device">
                                                <img
                                                    src={thumb}
                                                    alt={`Screen 0${nr}`}
                                                    className="ipad-screen cursor-pointer"
                                                    onClick={() => setShowScreenNr(nr)}
                                                />
                                            </div>
                                        </div>
                                        <div className="image-label-pill">
                                            <div className="image-label-text">{`Image 0${nr}`}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="cursor-pointer">
                        <img
                            src={SCREENS.find(s => s.nr === showScreenNr)?.full}
                            alt={`Screen 0${showScreenNr}`}
                            className="ipad-screen"
                            style={{ width: "100%", maxHeight: "713px", overflow: "hidden", padding: "14px" }}
                            onClick={() => setShowScreenNr(null)}
                        />
                    </div>
                )}
            </div>
        </StyledPage>
    );
}
